/**
 * Fades/slides [data-reveal] elements into place the first time they enter
 * the viewport. Only runs when `.js-reveal` is on <html> (set synchronously
 * in header.php) — that flag already accounts for prefers-reduced-motion
 * and IntersectionObserver support, so this module can assume both here.
 */
export function initScrollReveal() {
	if ( ! document.documentElement.classList.contains( 'js-reveal' ) ) {
		return;
	}

	const items = Array.from( document.querySelectorAll( '[data-reveal]' ) );

	if ( ! items.length ) {
		return;
	}

	// Stagger siblings that reveal together (e.g. a row of cards) instead of
	// having them all pop in at once. Grouped by shared parent, capped so a
	// long grid doesn't end up with a multi-second tail.
	const siblingIndex = new Map();
	items.forEach( ( el ) => {
		const parent = el.parentElement;
		const index = siblingIndex.get( parent ) || 0;
		el.style.setProperty( '--reveal-delay', `${ Math.min( index, 5 ) * 130 }ms` );
		siblingIndex.set( parent, index + 1 );
	} );

	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( ! entry.isIntersecting ) {
					return;
				}
				entry.target.classList.add( 'is-visible' );
				observer.unobserve( entry.target );
			} );
		},
		{ threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
	);

	items.forEach( ( el ) => observer.observe( el ) );
}
